import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@air/primitive-button";
import { memo } from "react";
import { ASSET_SHARE_BUTTON_PUBLIC } from "~/constants/testIDs";
export const HeaderShareButton = /*#__PURE__*/ memo((props)=>{
    return /*#__PURE__*/ _jsx(Button, {
        appearance: "filled",
        color: "grey",
        "data-testid": ASSET_SHARE_BUTTON_PUBLIC,
        size: "large",
        ...props,
        children: "Share"
    });
});
HeaderShareButton.displayName = "HeaderShareButton";
